module.exports = __webpack_public_path__ + "static/media/euro.6be28595.svg";